import { FC, useState, useEffect, useMemo } from 'react'
import Swal from 'sweetalert2'
import { StatusLoteModalProps } from '../type'
import { useProduct } from '../factory/useProduct'
import { i18n } from '../../../../../../translate/i18n'
import { POST } from '../../../../../../services/api'
import { ModularDataTable, TableSelection } from '../../../../../../components/ModularDataTable'
import { createColumnsModalGrupo } from '../factory/generateColumns'
import { FilterOptions } from '../components/filterOptions'
import Select from 'react-select'



export const GrupoLoteModal: FC<StatusLoteModalProps> = ({
    isOpen,
    onClose,
}) => {
    const [items, setItems] = useState<any[]>([])
    const [selectedProducts, setSelectedProducts] = useState<TableSelection>({ selectedRows: [], selectAll: false })

    const [selectedGroups, setSelectedGroups] = useState<any[]>([])

    const {
        tableLoading, productFilters, loading, pagination, sorting, categories, registeredGroups,
        setTableLoading, setLoading, getProducts, handleDataChange, handlePaginationChange,
        handleSortingChange, handleFilterChange, getCategories, getCustomersGroups, deleteProduct
    } = useProduct('grupoLoteModal', 'grupoLoteModal')



    // Opções para o Select de grupos
    const groupOptions = useMemo(() =>
        (registeredGroups || []).map((g: any) => ({ value: g.id, label: g.name || g.nome || g.label || g.id })),
        [registeredGroups]
    )
    async function filterProduct() {
        setTableLoading(true)
        const itensRes = await getProducts()
        setItems(itensRes)
        setTableLoading(false)
    }


    // Adiciona grupos selecionados aos produtos selecionados
    const handleAddGroupsToSelecteds = () => {
        if (selectedProducts.selectedRows.length === 0 || selectedGroups.length === 0) return
        setTableLoading(true)
        const newItems = items.map((item, index) => {
            if (selectedProducts.selectedRows.includes(index)) {
                // Garante que não duplica grupos
                const currentGroups = Array.isArray(item.group) ? item.group : []
                const newGroupIds = selectedGroups.map(g => g.label)
                const mergedGroups = Array.from(new Set([...currentGroups, ...newGroupIds]))
                return { ...item, group: mergedGroups }
            }
            return item
        })
        setItems(newItems)
        setTimeout(() => { setTableLoading(false) }, 100)
    }

    // Remove grupos selecionados dos produtos selecionados
    const handleRemoveGroupsFromSelecteds = () => {
        if (selectedProducts.selectedRows.length === 0 || selectedGroups.length === 0) return
        setTableLoading(true)
        const newItems = items.map((item, index) => {
            if (selectedProducts.selectedRows.includes(index)) {
                const currentGroups = Array.isArray(item.group) ? item.group : []
                const removeGroupIds = selectedGroups.map(g => g.label)
                const filteredGroups = currentGroups.filter((gid: any) => !removeGroupIds.includes(gid))
                return { ...item, group: filteredGroups }
            }
            return item
        })
        setItems(newItems)
        setTimeout(() => { setTableLoading(false) }, 100)
    }


    const columns = useMemo(
        () => createColumnsModalGrupo(),
        []
    )


    async function loadPage() {
        setLoading(true)
        await getCategories()
        await getCustomersGroups()
        const itensRes = await getProducts()
        setItems(itensRes)
        setLoading(false)
    }

    useEffect(() => {
        if (isOpen) {
            loadPage()
        } else {
            setItems([])
            setSelectedProducts({ selectedRows: [], selectAll: false })
        }
    }, [isOpen])



    const handleRemoveGroupSelecteds = () => {
        setTableLoading(true)
        const newItems = items.map((item, index) => {
            if (selectedProducts.selectedRows.includes(index)) {
                return { ...item, group: [] }
            }
            return item
        })
        setItems(newItems)
        setTimeout(() => { setTableLoading(false) }, 100)
    }

    const handleUpdateGroup = async () => {
        try {
            if (selectedProducts.selectedRows.length === 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Nenhum item selecionado',
                    text: 'Selecione pelo menos um item para atualizar!',
                })
                return
            }

            const itemsToUpdate = selectedProducts
                .selectedRows.map(index => items[index])
                .map(item => {
                    const grupo: string[] = item.group
                    const groupsID = registeredGroups.filter((g: { name: string, id: number }) => grupo.includes(g.name)).map((g:{ name: string, id: number }) => g.id)
                    return {
                        id: item.id,
                        groupsId: groupsID
                    }
                })

            setLoading(true)

            const response = await POST('/product/grupo-lote', itemsToUpdate)

            setLoading(false)

            if (response.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: 'Estoque atualizado em lote com sucesso!',
                }).then(() => {
                    setSelectedProducts({ selectedRows: [], selectAll: false })
                    setSelectedGroups([])
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: response.message || 'Erro ao atualizar estoque!',
                })
            }
        } catch (error: any) {
            setLoading(false)
            console.error('Erro ao atualizar inventário:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: error?.message || 'Erro ao atualizar estoque!',
            })
        }
    }

    if (!isOpen) return null

    return (
        <div className='modal fade show d-block' style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className='modal-dialog modal-xl'>
                <div className='modal-content'>
                    <div className='modal-header'>
                        <h5 className='modal-title'>Atualizar Grupo em Lote</h5>
                        <button
                            type='button'
                            className='btn-close'
                            onClick={onClose}
                            disabled={loading}
                        ></button>
                    </div>
                    <div className='modal-body'>
                        <div className='mb-3'>
                            <label className='form-label'>Selecione os grupos para adicionar/remover:</label>
                            <Select
                                isMulti
                                options={groupOptions}
                                value={selectedGroups}
                                onChange={value => setSelectedGroups(Array.isArray(value) ? [...value] : [])}
                                placeholder='Selecione grupos...'
                                isDisabled={loading || groupOptions.length === 0}
                            />
                            <div className='mt-2 d-flex gap-2'>
                                <button
                                    type='button'
                                    className='btn btn-success btn-sm'
                                    onClick={handleAddGroupsToSelecteds}
                                    disabled={selectedProducts.selectedRows.length === 0 || selectedGroups.length === 0}
                                >
                                    Adicionar Grupo aos Selecionados
                                </button>
                                <button
                                    type='button'
                                    className='btn btn-warning btn-sm'
                                    onClick={handleRemoveGroupsFromSelecteds}
                                    disabled={selectedProducts.selectedRows.length === 0 || selectedGroups.length === 0}
                                >
                                    Remover Grupo dos Selecionados
                                </button>


                                <button
                                    type='button'
                                    className='btn btn-danger'
                                    onClick={handleRemoveGroupSelecteds}
                                    disabled={selectedProducts.selectedRows.length === 0}
                                >
                                    Remover Todos os Grupos dos Selecionados
                                </button>
                            </div>
                        </div>
                        <div className='mb-3'>
                            <FilterOptions
                                productFilters={productFilters}
                                handleFilterChange={handleFilterChange}
                                filterProduct={filterProduct}
                                categories={categories}
                                registeredGroups={registeredGroups}
                            />
                        </div>

                        <div className='table-responsive' style={{ maxHeight: '550px', overflow: 'auto' }}>
                            <ModularDataTable
                                data={items}
                                columns={columns}
                                pagination={pagination}
                                onPaginationChange={handlePaginationChange}
                                sorting={sorting}
                                onSortingChange={handleSortingChange}
                                onDataChange={handleDataChange}
                                //onFilterChange={handleFilterChange}
                                searchable={true}
                                searchPlaceholder='Pesquisar produtos...'
                                loading={tableLoading}
                                onSelectionChange={setSelectedProducts}
                                selection={selectedProducts}
                                selectable={true}
                                striped={false}
                                hover={false}
                                size='md'
                                className='table-row-bordered table-row-gray-200'
                            />
                        </div>

                        <div className='alert alert-info mt-3'>
                            <i className='bi bi-info-circle me-2'></i>
                            <strong>Dica:</strong> Selecione os itens que deseja atualizar e clique em "Atualizar Grupo".
                        </div>
                    </div>
                    <div className='modal-footer'>
                        <button
                            type='button'
                            className='btn btn-light'
                            onClick={onClose}
                            disabled={loading}
                        >
                            {i18n.t('buttons.cancel')}
                        </button>
                        <button
                            type='button'
                            className='btn btn-primary'
                            onClick={handleUpdateGroup}
                            disabled={loading || selectedProducts.selectedRows.length === 0}
                        >
                            {loading ? (
                                <>
                                    <span className='spinner-border spinner-border-sm me-2' role='status'></span>
                                    Atualizando...
                                </>
                            ) : (
                                'Atualizar Grupos'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
